module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product25-a240a6cf7d0de95b58faab4382247eb8.jpg";